const my_profile = {
  viewMyClubSeacretProfile: "הצג את פרופיל ClubSeacret שלי", // translated
  viewMoreDetails: "הצג פרטים נוספים", // translated
  verifiedEmail: "אימייל מאומת", // translated
  unverifiedEmail: "אימייל לא מאומת", // translated
  createdFrom: "נוצר מ", // translated
  createdTo: "נוצר עד", // translated
  selectStatus: "בחר סטטוס...", // translated
  searchByTitle: "חפש לפי כותרת...", // translated
};

export default my_profile;
